import { Component, Input, OnInit } from '@angular/core';
import { unescape } from 'lodash';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-icd-search',
    templateUrl: './icd-search.component.html',
    styleUrls: ['./icd-search.component.scss'],
    standalone: false
})
export class IcdSearchComponent implements OnInit {
  currentData: any = {};

  constructor(
    public config: DialogConfig,
    public baseService: BaseService,
    private loader: LoaderService,
    public alerts: AlertsService,
    public dialog: DialogRef
  ) {
  }

  ngOnInit(): void {
    console.log("config ", this.config);
    this.currentData.question = this.config && this.config.data && this.config.data.question ? this.config.data.question : undefined;
    let args = "uri:icd.who.int/browse10/2019/en/JsonGetRootConcepts?useHtml=true";
    this.loader.showSpinner();
    this.baseService.get("GET_ICD_DATA", args, "emrpatient", "emr").subscribe(data => {
      if (data.errCode == 0 && data.resource && data.resource.length > 0) {
        this.currentData.rootData = JSON.parse(data.resource[0].clinicalCounsellingGivenTo);
        this.currentData.show_sections = true;
      }
      this.loader.hideSpinner();
    });
    this.currentData.selectedData = [];
  }
  

  keySelection(data, event){
    this.currentData = data;
    const divs = document.querySelectorAll('.oneentity');
    divs.forEach(el => el.addEventListener('click', event => {
      console.log(event.currentTarget['outerText']);
      let arr = event.currentTarget['outerText'].split(" ");
      let q =this.currentData.question;
      let hasNumber = /\d/;  
      if(event.currentTarget['classList'].contains('selected')){
        event.currentTarget['classList'].remove('selected');
        const findIndex = this.currentData.selectedData.findIndex(a => a[q.getterKey] === arr[0]);
        this.currentData.selectedData.splice(findIndex, 1);
      }else{
        event.currentTarget['classList'].add('selected');
        let obj = {};
        if(q)
        obj[q.getterKey] = arr[0];
        else
        obj['id'] = arr[0];
        arr.shift();
        if(hasNumber.test(arr[arr.length -1])){
          arr.splice(arr.length -1);
        }
        let string = '';
        arr.forEach(elem=>{
          string += elem + " ";
        });
        if(q)
          obj[q.getterValue] = string.substring(0, string.length - 1);
        else
          obj['text'] = string.substring(0, string.length - 1);
        obj['coding_system'] = 'icd_10';
        this.currentData.selectedData.push(obj);
      }
    }));
  }

  handleKeyEnter(event) {
    let e: any;
    if(event == ''){
      e = this.currentData.filterKey.trim();
    }else
      e = event.target.value.trim();
    this.currentData.show = false;
    this.currentData.show_sections = true;
    this.currentData.searchedData = undefined;
    if (this.currentData.searchedData == undefined || (this.currentData.searchedData != undefined && this.currentData.searchedData != e)) {
      this.loader.showSpinner();
      this.currentData.searchedData = e;
      let args = "uri:icd.who.int/browse10/2019/en/ACSearch?useHtml=false&q=" + encodeURIComponent(e);
      let data = {
        args: args
      }
      this.currentData.triggered = true;
      this.baseService.getData(data, '', "emrpatient", "emr", "GET_ICD_DATA").subscribe(data => {
        if (data.errCode == 0 && data.resource && data.resource.length > 0) {
          this.currentData.searchData = unescape(data.resource[0].clinicalCounsellingGivenTo);
          this.currentData.show = true;
          this.currentData.show_sections = false;
          setTimeout(() => {
            // Your CSS as text
            var styles = `
            .pvsdetails{
              display: none;
            }
            span.detailsiconatpv {
              display: none;
            }
            span.detailsicon {
              display: none;
            } 
            .toplevel li{
                list-style: none;
            }
            .selected{
              color: #2785a5;
            }
            em.wbe {
              color: #d45800;
            }
            .searchresults {
              background: white;
              height: 65vh;
              overflow-x: hidden;
              overflow-y: auto;
              margin-top: 3px;
              border-radius: 5px;
              border: 1px solid #ccc;
              margin-bottom: 20px;
           }`
            var styleSheet = document.createElement("style");
            styleSheet.innerText = styles;
            document.head.appendChild(styleSheet);
            this.keySelection(this.currentData, event);
          });
        }
      this.loader.hideSpinner();
      });
    }else{
      this.currentData.show = true;
    }
    if(event != '' && event != null && event != undefined)
      event.preventDefault();
  }

  toggleSearchBox(){
    this.currentData.show = !this.currentData.show;
    if(this.currentData.show){
      this.currentData.show_sections = false;
      this.currentData.searchedData = undefined;
      this.handleKeyEnter("");
    }
    else
      this.currentData.show_sections = true;
  }
  
  getChild(cd) {
    this.loader.showSpinner();
    if (cd.isLeaf != undefined && !cd.isLeaf && cd.child != undefined && cd.selectedNode){
      if(cd.hidden == undefined || !cd.hidden){
        cd.hidden = true;
        cd.child.forEach((el, i) => {
          el.selectedNode = false;
          if(el.child && el.child.length > 0){
            el.hidden = true;
            this.removeDataFromICD(el.child);
          }
        });
      }else{
        cd.hidden = false;
        cd.child.forEach(el => {
          el.selectedNode = true;
        });
      }
      this.loader.hideSpinner();
    } else if (cd.isLeaf != undefined && !cd.isLeaf && cd.child == undefined) {
      if(cd.padding==undefined)
        cd.padding= 0;
      let args = "uri:icd.who.int/browse10/2019/en/JsonGetChildrenConcepts?ConceptId=" + cd.ID + "&useHtml=true&showAdoptedChildren=true";
      this.baseService.get("GET_ICD_DATA", args, "emrpatient", "emr").subscribe(data => {
        if (data.errCode == 0 && data.resource && data.resource.length > 0) {
          let res = JSON.parse(data.resource[0].clinicalCounsellingGivenTo);
          res.forEach(el => {
            el.parentId = cd.ID;
            el.padding = cd.padding+10;
          });
          cd.child = res;
          cd.selectedNode = true;
          console.log("Root ", this.currentData.rootData);
          this.loader.hideSpinner();
        }else
        this.loader.hideSpinner();
      });
    }
  }

  selectChild(cd){
    if ((cd.isLeaf != undefined && cd.isLeaf) || (cd.averageDepth == 2 || cd.averageDepth == 3)) {
      if(cd.selected == undefined || !cd.selected){
        cd.selected = true;
        let response: any = {};
        let text = (this.convertToPlain(cd.html)).trim();
        let ar = text.split("\n");
        if(this.currentData.question){
          let q =this.currentData.question;
          response[q.getterValue] = ar[1];
          response[q.getterKey] = cd.ID;
        }else{
          response.text = ar[1];
          response.id = cd.ID;
        }
        response['coding_system'] = 'icd_10';
        if (this.currentData.question && this.currentData.question.defaultsetting && this.currentData.question.defaultsetting.singleSelection) {
          this.dialog.close(response);//single selection enable
        }
        else
          this.currentData.selectedData.push(response);
      }else{
        cd.selected = false;
        let q =this.currentData.question;
        const findIndex = this.currentData.selectedData.findIndex(a => a[q.getterKey] === cd.ID);
        this.currentData.selectedData.splice(findIndex, 1);
      }
    }else{
      this.getChild(cd);
    }
  }

  removeDataFromICD(child){
    if(child && child.length > 0){
      child.forEach(el => {
        el.selectedNode = false;
        if(el.child && el.child.length > 0){
          el.hidden = true;
          this.removeDataFromICD(el.child);
        }
      });
    }
  }

  submitBtn(){
    if(this.currentData.selectedData && this.currentData.selectedData.length > 0)
      this.dialog.close(this.currentData.selectedData); 
    else
      this.alerts.error("Select Item");
  }

  convertToPlain(html) {
    let tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }

}
